import { RAISE_DISPUTE, RAISE_DISPUTE_SUCCESS, RAISE_DISPUTE_ERROR, RAISE_DISPUTE_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RaiseDispute = (state = initialState, action) => {
  switch (action.type) {
    case RAISE_DISPUTE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case RAISE_DISPUTE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case RAISE_DISPUTE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case RAISE_DISPUTE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RaiseDispute;
